export const testimonials = [
  {
    name: "小满",
    role: "追了六届选美的老观众",
    quote:
      "别的地方只会截最尴尬的三秒疯狂刷，这里是少数会把前后语境讲清楚的。看完还能笑，但笑完不觉得亏心。",
  },
  {
    name: "阿哲",
    role: "娱乐区内容创作者",
    quote:
      "写盘点最怕素材乱，这里每条都标了来源类型，还给了时间线，直接省掉我一半整理时间。",
  },
  {
    name: "圆圆",
    role: "高校礼仪社成员",
    quote:
      "我们是当作临场反应案例在看的。劈叉救场那篇被我们社团内部转了三轮，比形体课还实用。",
  },
];

export const gallery = [
  {
    src: "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20warmly%20lit%20judge%20desk%20with%20a%20hand%20holding%20a%20pen%20over%20a%20scorecard%2C%20soft%20amber%20lighting%2C%20editorial%20photography%2C%20cream%20tones&width=600&height=600&seq=gallery-judge-a1&orientation=squarish",
    alt: "评委席上评判打分的特写画面",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Elegant%20empty%20chair%20beside%20a%20pageant%20stage%20under%20warm%20spotlight%20with%20red%20curtains%2C%20editorial%20photography%2C%20warm%20amber%20tones&width=600&height=600&seq=gallery-judge-b2&orientation=squarish",
    alt: "舞台边评委座椅在暖光下的画面",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Glass%20of%20water%20and%20notebook%20on%20a%20wooden%20table%20under%20warm%20spotlight%2C%20quiet%20backstage%20mood%2C%20editorial%20photography%2C%20amber%20and%20cream%20tones&width=600&height=600&seq=gallery-judge-c3&orientation=squarish",
    alt: "评委桌上水杯与记录本的特写",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Rows%20of%20seats%20in%20a%20warmly%20lit%20theater%20facing%20a%20bright%20stage%2C%20editorial%20photography%2C%20warm%20amber%20tones%2C%20cinematic%20depth&width=600&height=600&seq=gallery-judge-d4&orientation=squarish",
    alt: "剧场观众席朝向舞台的画面",
  },
];